import { MdSettingsBackupRestore } from "react-icons/all";
import { useColorModeValue, VStack } from "@chakra-ui/react";

import { useGetThemeColors } from "ChakraTheme";
import { ChakraText } from "components/ChakraText";
import { Icon } from "components/Icon";
import { Form, IErrorField, SpinnerButton, TextField } from "components/Form";

import { useRemindPassword } from "../infrastructure/useRemindPassword";
import { useRemindPasswordNotification } from "./useRemindPasswordNotification";
import { remindPasswordValidationSchema } from "../application/validation/remindPasswordValidationSchema";

interface IProps {
  onCloseModal: () => void;
}

const RemindPasswordForm = ({ onCloseModal }: IProps) => {
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.white, colors.black);
  const {
    showSuccessNotification,
    showErrorNotification,
  } = useRemindPasswordNotification();
  const mutation = useRemindPassword();

  const handleSubmit = async (
    model: { email: string },
    setCustomErrors: (errors: IErrorField[]) => void
  ) => {
    const formData = new FormData();
    Object.keys(model).forEach((key) => {
      formData.append(key, model[key as keyof typeof model].toString());
    });
    try {
      await mutation.mutateAsync(formData);
      showSuccessNotification();
      onCloseModal();
    } catch (e) {
      if (e.status === 400) {
        setCustomErrors(e.response.msg);
      }
      showErrorNotification(e.message);
    }
  };

  return (
    <Form<{ email: string }>
      onSubmit={handleSubmit}
      defaultValues={{
        email: "",
      }}
      validationSchema={remindPasswordValidationSchema}
      resetOnSubmit={false}
    >
      {() => {
        return (
          <VStack spacing={4} align="stretch">
            <TextField label="Adres email" name="email" />

            <VStack spacing={4} mt={8}>
              <SpinnerButton
                btnTitle={<ChakraText>Wyślij link</ChakraText>}
                leftIcon={
                  <Icon color={iconColor} icon={MdSettingsBackupRestore} />
                }
                id="send-remind-password-btn"
                w="250px"
              />
            </VStack>
          </VStack>
        );
      }}
    </Form>
  );
};

export { RemindPasswordForm };
